import React from 'react';
import StaticPageTemplate from '../components/ui/StaticPageTemplate';
import styled from 'styled-components';
import { visionMissionPageQuery } from '../queries';

const VisionMissionGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  margin-top: 2rem;
  
  @media (min-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }
`;

const VisionMissionCard = styled.div`
  background-color: ${({ theme }) => theme.colors.lightBackground};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  padding: 2rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  
  h2 {
    color: ${({ theme }) => theme.colors.primary};
    margin-bottom: 1rem;
    margin-top: 0;
  }
  
  p {
    line-height: 1.6;
    margin-bottom: 0;
  }
`;

const VisionMission = () => {
  const defaultData = {
    title: "Vision & Mission",
    subtitle: "Our commitment to excellence in care",
    visionHeader: "Our Vision",
    visionText: "To be the leading provider of quality care services in our community.",
    missionHeader: "Our Mission",
    missionText: "To provide compassionate, professional care that enhances the quality of life for all our residents.",
    commitmentHeader: "Our Commitment",
    commitmentText: "We are committed to maintaining the highest standards of care and service excellence."
  };

  const customContent = (pageData) => (
    <VisionMissionGrid>
      <VisionMissionCard>
        <h2>{pageData.visionHeader}</h2>
        <p>{pageData.visionText}</p>
      </VisionMissionCard>
      
      <VisionMissionCard>
        <h2>{pageData.missionHeader}</h2>
        <p>{pageData.missionText}</p>
      </VisionMissionCard>
      
      <VisionMissionCard>
        <h2>{pageData.commitmentHeader}</h2>
        <p>{pageData.commitmentText}</p>
      </VisionMissionCard>
    </VisionMissionGrid>
  );

  return (
    <StaticPageTemplate
      pageName="visionMissionPage"
      query={visionMissionPageQuery}
      defaultData={defaultData}
      customContent={customContent}
    />
  );
};

export default VisionMission;
